const fonts = {
    easyRead: { name: "Default", class: "font-sentient" },
    spectral: {
        name: "Zodiak",
        class: "font-zodiak",
    },
    crimson: {
        name: "Modern",
        class: "font-poppins",
    },
};

export default fonts;
